module.exports = __webpack_public_path__ + "static/media/jardines03M.c036b07e.jpg";